










































































































import { Component, Mixins } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import AddNewCategory from '@/components/Admin/Panels/Ticket/AddNewCategory.vue';
import EditCategory from '@/components/Admin/Panels/Ticket/EditCategory.vue';
import EditInquiry from '@/components/Admin/Panels/Ticket/EditInquiry.vue';
import AddNewInquiry from '@/components/Admin/Panels/Ticket/AddNewInquiry.vue';
import draggable from 'vuedraggable';
import NotifyMethods from '@/mixins/NotifyMethods.vue';
import ProjectsData from '@/ts/ProjectsData';

@Component({
    components: {
        AddNewCategory,
        EditCategory,
        EditInquiry,
        AddNewInquiry,
        draggable,
    },
    computed: {
        ...mapGetters({
            addCategoryVisible: 'TicketAttributes/getAddCategoryVisible',
            editCategoryVisible: 'TicketAttributes/getEditCategoryVisible',
            addInquiryVisible: 'TicketAttributes/getAddInquiryVisible',
            editInquiryVisible: 'TicketAttributes/getEditInquiryVisible',
            ticketAllTypes: 'TicketAttributes/getTicketAllTypes',
            ticketAllCategories: 'TicketAttributes/getTicketAllCategories',
            ticketAllInquiries: 'TicketAttributes/getTicketAllInquiries',
        }),
    },
})
export default class TicketAttributes extends Mixins(NotifyMethods) {
    public dragOptions: any = {};

    constructor() {
        super();
    }

    get projects(): ProjectsData[] {
        return this.$store.getters['Projects/allProjects'];
    }

    get currentTicketType() {
        return this.$store.getters['TicketAttributes/getCurrentTicketType'];
    }

    get currentTicketCategory() {
        return this.$store.getters['TicketAttributes/getCurrentTicketCategory'];
    }

    get selectedProjectId() {
        return Number(this.$store.getters['TicketAttributes/getCurrentProject']);
    }

    public setTicketCurrentType(ev: any, typeId: number) {
        if (this.$store.getters['TicketAttributes/getCurrentProject'] === 0 || this.$store.getters['TicketAttributes/getCurrentProject'] === '0') {
            return this.notify('please_select_project_first', 'warning');
        }

        const ticketHierarchyItem = ev.srcElement.classList.contains('ticket-hierarchy-type-item') ? ev.srcElement : ev.srcElement.parentElement;

        this.resetTicketAllTypes();
        this.resetTicketAllCategories();
        ticketHierarchyItem.classList.add('ticket-hierarchy__active');

        this.$store.commit(Mutations.SET_CURRENT_TICKET_TYPE, typeId);

        this.$store.commit(Mutations.SET_CURRENT_TICKET_CATEGORY, 0);
        this.$store.commit(Mutations.SET_TICKET_ALL_INQUIRIES, []);
        this.$store.commit(Mutations.SET_TICKET_ALL_CATEGORIES, []);

        this.$store.dispatch(Actions.FETCH_TICKET_ALL_CATEGORIES, { projectId: this.selectedProjectId, typeId, trash: false });
    }

    public setTicketCurrentCategory(ev: any, categoryId: number) {
        this.resetTicketAllCategories();

        const ticketHierarchyItem = ev.srcElement.classList.contains('ticket-hierarchy-category-item') ? ev.srcElement : ev.srcElement.parentElement;
        ticketHierarchyItem.classList.add('ticket-hierarchy__active');

        this.$store.commit(Mutations.SET_CURRENT_TICKET_CATEGORY, categoryId);
        this.$store.commit(Mutations.SET_TICKET_ALL_INQUIRIES, []);

        this.$store.dispatch(Actions.FETCH_TICKET_INQUIRIES, {
            typeId: this.$store.getters['TicketAttributes/getCurrentTicketType'],
            categoryId,
            projectId: this.$store.getters['TicketAttributes/getCurrentProject'],
        });
    }

    public setCurrentProject(ev: any) {
        this.resetTicketAllCategories();
        this.resetTicketAllTypes();

        this.$store.commit(Mutations.SET_CURRENT_TICKET_TYPE, 0);
        this.$store.commit(Mutations.SET_CURRENT_TICKET_CATEGORY, 0);
        this.$store.commit(Mutations.SET_CURRENT_PROJECTS, ev.srcElement.value);

        this.$store.commit(Mutations.SET_TICKET_ALL_INQUIRIES, []);
        this.$store.commit(Mutations.SET_TICKET_ALL_CATEGORIES, []);
    }

    public addNewCategoryModal() {
        this.$store.commit(Mutations.SET_ADD_CATEGORY_VISIBILITY, true);
    }

    public editCategoryModal(categoryId: number) {
        this.$store.dispatch(Actions.FETCH_CURRENT_EDIT_CATEGORY, categoryId);
    }

    public addNewInquiryModal() {
        this.$store.commit(Mutations.SET_ADD_INQUIRY_VISIBILITY, true);
    }

    public editInquiryModal(inquiryId: number) {
        this.$store.dispatch(Actions.FETCH_CURRENT_EDIT_INQUIRY, {
            projectId: this.$store.getters['TicketAttributes/getCurrentProject'],
            inquiryId,
        });
    }

    public resetTicketAllTypes() {
        for (const item of document.getElementsByClassName('ticket-hierarchy-type-item')) {
            item.classList.remove('ticket-hierarchy__active');
        }
    }

    public resetTicketAllCategories() {
        for (const item of document.getElementsByClassName('ticket-hierarchy-category-item')) {
            item.classList.remove('ticket-hierarchy__active');
        }
    }

    public checkDragMove(ev: any) {
        const itemId = ev.draggedContext.element.id;
        const relatedId = ev.relatedContext.element.id;
        const direction = ev.draggedContext.futureIndex < ev.draggedContext.index ? 'up' : 'down';

        const typeId     = this.currentTicketType;
        const categoryId = this.currentTicketCategory;

        this.dragOptions = { itemId, relatedId, direction, typeId, categoryId };
    }

    public dragEnded(ev: any, type: string) {
        if (Object.keys(this.dragOptions).length === 0) {
            return false;
        }

        switch (type) {
            case 'type':
                this.$store.dispatch(Actions.UPDATE_INQUIRY_TYPE_SORT, this.dragOptions);
                break;
            case 'category':
                this.$store.dispatch(Actions.UPDATE_INQUIRY_CATEGORY_SORT, this.dragOptions);
                break;
            case 'inquiry':
                this.$store.dispatch(Actions.UPDATE_INQUIRY_SORT, this.dragOptions);
                break;
        }
    }

    public created() {
        this.$store.commit(Mutations.SET_CURRENT_PROJECTS, 0);
        this.$store.commit(Mutations.SET_CURRENT_TICKET_TYPE, 0);
        this.$store.commit(Mutations.SET_CURRENT_TICKET_CATEGORY, 0);
        this.$store.commit(Mutations.SET_TICKET_ALL_INQUIRIES, []);
    }

    public mounted() {
        this.$store.dispatch(Actions.FETCH_TICKET_ALL_TYPES);
    }
}
